import { render, staticRenderFns } from "./blog-4.vue?vue&type=template&id=d282b02e&scoped=true"
import script from "./blog-4.vue?vue&type=script&lang=js"
export * from "./blog-4.vue?vue&type=script&lang=js"
import style0 from "./blog-4.vue?vue&type=style&index=0&id=d282b02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d282b02e",
  null
  
)

export default component.exports